import { IIsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";

export interface IIsiDtoPlDesignResponse extends IIsiDtoPresentationLogicResponse  {
    result?: IIsiDtoPlDesignResult;
    returnedResponse?: string;
}
export interface IIsiDtoPlDesignResult extends IIsiDataTransferObject  {
    sysCtrlsValue?: string;
    disabledSysCtrls?: string[];
}
export class IsiDtoPlDesignResult extends IsiDataTransferObject implements IIsiDtoPlDesignResult {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.Design.IsiDtoPlDesignResult, Isilog.IsiComponent.IsiDataTransferObject";
    sysCtrlsValue?: string;
    disabledSysCtrls?: string[];

    constructor(data?: IIsiDtoPlDesignResult) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sysCtrlsValue = _data["sysCtrlsValue"] !== undefined ? _data["sysCtrlsValue"] : <any>null;
            this.disabledSysCtrls = _data["disabledSysCtrls"] !== undefined ? _data["disabledSysCtrls"] : [];
        }
    }

    static fromJS(data?: IIsiDtoPlDesignResult): IsiDtoPlDesignResult {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlDesignResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["sysCtrlsValue"] = this.sysCtrlsValue !== undefined ? this.sysCtrlsValue : <any>null;
        data["disabledSysCtrls"] = this.disabledSysCtrls !== undefined ? this.disabledSysCtrls : [];
        return data;
    }
}
export class IsiDtoPlDesignResponse extends IsiDtoPresentationLogicResponse implements IIsiDtoPlDesignResponse {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.Design.IsiDtoPlDesignResponse, Isilog.IsiComponent.IsiDataTransferObject";
    result?: IsiDtoPlDesignResult;
    returnedResponse?: string;

    constructor(data?: IIsiDtoPlDesignResponse) {
        super(data);
        if (data) {
            this.result = data.result && !(<any>data.result).toJSON ? new IsiDtoPlDesignResult(data.result) : <IsiDtoPlDesignResult>this.result;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.result = _data["result"] ? IsiDtoPlDesignResult.fromJS(_data["result"]) : <any>null;
            this.returnedResponse = _data["returnedResponse"] !== undefined ? _data["returnedResponse"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlDesignResponse): IsiDtoPlDesignResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlDesignResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["result"] = this.result != null ? (<any>this.result).toJSON() : <any>null;
        data["returnedResponse"] = this.returnedResponse !== undefined ? this.returnedResponse : <any>null;
        return data;
    }
}
export interface IIsiDtoPlDesignRequest extends IIsiDtoPresentationLogicRequest  {
    ctrlCode?: string;
    isRwd?: boolean;
    screenCode?: string;
    moduleCode?: string;
    profileCode?: string;
    deskCode?: number;
    connectFromBandeau?: string;
    response?: IIsiDtoPlDesignResponse;
}
export class IsiDtoPlDesignRequest extends IsiDtoPresentationLogicRequest implements IIsiDtoPlDesignRequest {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.Design.IsiDtoPlDesignRequest, Isilog.IsiComponent.IsiDataTransferObject";
    ctrlCode?: string;
    isRwd?: boolean;
    screenCode?: string;
    moduleCode?: string;
    profileCode?: string;
    deskCode?: number;
    connectFromBandeau?: string;
    response?: IsiDtoPlDesignResponse;

    constructor(data?: IIsiDtoPlDesignRequest) {
        super(data);
        if (data) {
            this.response = data.response && !(<any>data.response).toJSON ? new IsiDtoPlDesignResponse(data.response) : <IsiDtoPlDesignResponse>this.response;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ctrlCode = _data["ctrlCode"] !== undefined ? _data["ctrlCode"] : <any>null;
            this.isRwd = _data["isRwd"] !== undefined ? _data["isRwd"] : false;
            this.screenCode = _data["screenCode"] !== undefined ? _data["screenCode"] : <any>null;
            this.moduleCode = _data["moduleCode"] !== undefined ? _data["moduleCode"] : <any>null;
            this.profileCode = _data["profileCode"] !== undefined ? _data["profileCode"] : <any>null;
            this.deskCode = _data["deskCode"] !== undefined ? _data["deskCode"] : null;
            this.connectFromBandeau = _data["connectFromBandeau"] !== undefined ? _data["connectFromBandeau"] : <any>null;
            this.response = _data["response"] ? IsiDtoPlDesignResponse.fromJS(_data["response"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlDesignRequest): IsiDtoPlDesignRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlDesignRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["ctrlCode"] = this.ctrlCode !== undefined ? this.ctrlCode : <any>null;
        data["isRwd"] = this.isRwd !== undefined ? this.isRwd : false;
        data["screenCode"] = this.screenCode !== undefined ? this.screenCode : <any>null;
        data["moduleCode"] = this.moduleCode !== undefined ? this.moduleCode : <any>null;
        data["profileCode"] = this.profileCode !== undefined ? this.profileCode : <any>null;
        data["deskCode"] = this.deskCode !== undefined ? this.deskCode : null;
        data["connectFromBandeau"] = this.connectFromBandeau !== undefined ? this.connectFromBandeau : <any>null;
        data["response"] = this.response != null ? (<any>this.response).toJSON() : <any>null;
        return data;
    }
}
